var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56618 3.8098C9.72547 3.8098 9.8846 3.87062 10.0062 3.99211C10.2492 4.23509 10.2492 4.62911 10.0062 4.87193L4.87291 10.0053C4.63009 10.2482 4.23575 10.2482 3.99309 10.0053C3.74995 9.76213 3.74995 9.36827 3.99309 9.12529L9.12642 3.99196C9.24775 3.87062 9.40689 3.8098 9.56618 3.8098Z",
    fill: "#EC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.433 3.80964C4.59213 3.80964 4.75158 3.87047 4.87291 3.99195L10.0062 9.12529C10.2492 9.36842 10.2492 9.76229 10.0062 10.0053C9.76311 10.2482 9.36924 10.2482 9.12627 10.0053L3.99293 4.87193C3.7498 4.62896 3.7498 4.23493 3.99293 3.99211C4.11442 3.87047 4.27387 3.80964 4.433 3.80964Z",
    fill: "#EC0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 -9.53674e-07C10.8598 -9.53674e-07 14 3.1402 14 7C14 10.8598 10.8598 14 7 14C3.1402 14 -9.53674e-07 10.8598 -9.53674e-07 7C-9.53674e-07 3.1402 3.1402 -9.53674e-07 7 -9.53674e-07ZM7 12.7556C10.1736 12.7556 12.7556 10.1736 12.7556 7C12.7556 3.82635 10.1736 1.24444 7 1.24444C3.82635 1.24444 1.24444 3.82635 1.24444 7C1.24444 10.1736 3.82635 12.7556 7 12.7556Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.332225645da1b28e86fc55224478c8e7.svg";
export { ForwardRef as ReactComponent };